var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropCards = function SvgDropCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.6 6.658v.594m0-2.97v-.198c0-.875.709-1.584 1.584-1.584h.198m6.336 0h.198c.875 0 1.585.71 1.585 1.584v.198M15.758 2.5h1.584m4.159 4.158v1.585m0 2.376v.198c0 .875-.71 1.584-1.585 1.584h-.198m-2.376 0h-.594M15.334 17.155h.424a.99.99 0 0 0 .99-.99V8.244a.99.99 0 0 0-.99-.99H7.837a.99.99 0 0 0-.99.99v3.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.371 15.68v-1.386a1.109 1.109 0 1 0-2.218 0v.777M9.153 14.847v-1.11a1.109 1.109 0 0 0-2.217 0v1.11M6.936 14.866v-.5a1.109 1.109 0 0 0-2.218 0v2.773M4.718 17.138a1.109 1.109 0 0 0-2.218 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.371 15.398a1.109 1.109 0 1 1 2.218 0v1.663a4.435 4.435 0 0 1-4.436 4.436H6.936A4.435 4.435 0 0 1 2.5 17.061a1.109 1.109 0 0 1 2.218 0"
  })));
};
export default SvgDropCards;